export default "__VITE_ASSET__Ckr04iDX__"